import { ChangeDetectionStrategy, Component, booleanAttribute, input, signal } from '@angular/core';
import { VhIconComponent } from '../icon/icon.component';

/**
 * Collapsible section wrapper for filter panel groups. Projects any
 * controls (checklist, price range, rating filter) as its body. Keep
 * the logic dumb — parents control selection state.
 */
@Component({
  selector: 'vh-filter-section',
  standalone: true,
  imports: [VhIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button
      type="button"
      class="vh-filter-section__trigger"
      [attr.aria-expanded]="expanded()"
      (click)="toggle()"
    >
      <span class="vh-filter-section__title">{{ title() }}</span>
      @if (activeCount() && activeCount()! > 0) {
        <span class="vh-filter-section__count">{{ activeCount() }}</span>
      }
      <vh-icon
        class="vh-filter-section__chev"
        [class.vh-filter-section__chev--open]="expanded()"
        name="chevron-down"
        size="sm"
      />
    </button>
    @if (expanded()) {
      <div class="vh-filter-section__body">
        <ng-content />
      </div>
    }
  `,
  styleUrl: './filter-section.component.scss',
})
export class VhFilterSectionComponent {
  readonly title = input.required<string>();
  readonly activeCount = input<number | null>(null);
  readonly defaultOpen = input(true, { transform: booleanAttribute });

  protected readonly expanded = signal(true);

  constructor() {
    queueMicrotask(() => this.expanded.set(this.defaultOpen()));
  }

  toggle(): void {
    this.expanded.update((v) => !v);
  }
}
